// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"Notification-49cffd94951134b0"};